import request from "@/utils/request";

const obj = {
  agentGetCreatLogByPage: function (params) {
    if (!params.phone) {
      params.memberType = null;
    }
    return request.get(
      `/device/carportMemberMonthlyLog/agentGetCreatLogByPage`,
      {
        params,
      }
    );
  },
  agentUnsubscribeMonthly: function (id) {
    return request.post(
      `/device/agent/carportMemberMonthlyLog/agentUnsubscribeMonthly`,
      {},
      {
        params: {
          orderId: id,
        },
      }
    );
  },
  agentUnsubscribeMonthlyOfCarportAndCharge: function (params) {
    let url = `/device/agent/carportMemberMonthlyLog/agentUnsubscribeMonthlyOfCarportAndCharge?orderSn=${params.orderSn}`;

    // 循环拼接，后端可数组接收
    for (const type of params.orderType) {
      url += `&orderTypeList=${type}`;
    }

    return request.post(url, {}, { timeout: 15000 });
  },
};
export default obj;
